<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div cdkDropListGroup class="custom-list">
    <div class="content">
        <span>Available</span>
        <div class="search">
            <div class="icon">
                <sui-svg-icon icon="search" windeGrey></sui-svg-icon>
            </div>
            <sui-string-component [config]="searchControl"></sui-string-component>
        </div>
        <div (cdkDropListDropped)="drop($event)" [cdkDropListData]="config.availableItems" [id]="multiSelectListType.AVAILABLE" cdkDropList>
            @for (item of config.availableItems; track item?.[this.displayName()] || item) {
                <div
                    (click)="availableClick(item)"
                    (keydown)="availableClick(item)"
                    cdkDrag
                    [cdkDragDisabled]="config.readonly"
                    [cdkDragData]="item"
                    [ngClass]="{ active: readyToBeSelected.has(item) }"
                >
                    {{ item?.[this.displayName()] || item }}
                </div>
            }
        </div>
    </div>

    <div class="buttons">
        <button (click)="select()" [disabled]="tooltipsAreDisabled" [hidden]="config.readonly" windeActionIcon>
            <sui-svg-icon
                icon="angle-right"
                suiTooltip
                tooltipText="{{ 'gtthApp.customListBox.button.copy' | translate }}"
                windeGrey
            ></sui-svg-icon>
        </button>

        <button (click)="config.selectAll()" [disabled]="tooltipsAreDisabled" [hidden]="config.readonly" windeActionIcon>
            <sui-svg-icon
                icon="angle-double-right"
                suiTooltip
                tooltipText="{{ 'gtthApp.customListBox.button.copyAll' | translate }}"
                windeGrey
            ></sui-svg-icon>
        </button>

        <button (click)="deselect()" [disabled]="tooltipsAreDisabled" [hidden]="config.readonly" windeActionIcon>
            <sui-svg-icon
                icon="angle-left"
                suiTooltip
                tooltipText="{{ 'gtthApp.customListBox.button.remove' | translate }}"
                windeGrey
            ></sui-svg-icon>
        </button>

        <button (click)="config.deselectAll()" [disabled]="tooltipsAreDisabled" [hidden]="config.readonly" windeActionIcon>
            <sui-svg-icon
                icon="angle-double-left"
                suiTooltip
                tooltipText="{{ 'gtthApp.customListBox.button.removeAll' | translate }}"
                windeGrey
            ></sui-svg-icon>
        </button>
    </div>

    <div class="content">
        <span>Selected</span>

        <div (cdkDropListDropped)="drop($event)" [cdkDropListData]="config.value" [id]="multiSelectListType.SELECTED" cdkDropList>
            @for (item of config.value; track item?.[this.displayName()] || item) {
                <div
                    cdkDrag
                    (click)="selectedClick(item)"
                    (keydown)="selectedClick(item)"
                    [cdkDragDisabled]="config.readonly"
                    [cdkDragData]="item"
                    [ngClass]="{ active: readyToBeDeselected.has(item) }"
                >
                    {{ item?.[this.displayName()] || item }}
                </div>
            }
        </div>
    </div>
</div>
